import React from 'react';
import { Container } from 'react-bootstrap';
import { FiTruck, FiHeadphones } from 'react-icons/fi';
import { TbPigMoney, TbLock } from 'react-icons/tb';
import styles from './bodywon.module.css';

const featuresData = [
  { icon: <FiTruck />, title: 'Free Shipping', description: 'For all Orders Over $1000' },
  { icon: <TbPigMoney />, title: '28 Days Returns', description: 'For an Exchange Product' },
  { icon: <TbLock />, title: 'Secured Payment', description: 'Payment Cards Accepted' },
  { icon: <FiHeadphones />, title: 'Support 24/7', description: 'Contact us Anytime' },
];

const SiteFeatures = () => {
  return (
    <section className={styles.featuresSection}>
      <Container>
        <div className={styles.featuresGrid}>
          {featuresData.map((feature, index) => (
            <div key={index} className={styles.featureItem}>
              <div className={styles.featureIcon}>
                {feature.icon}
              </div>
              <div className={styles.featureText}>
                <h5>{feature.title}</h5>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default SiteFeatures;
